var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-search"},[_c('div',{staticClass:"m-search-hadnle flex-center-cross"},[_c('c-button',{staticClass:"button",on:{"click":_vm.search}},[_vm._v("查询")]),_c('c-button',{staticClass:"button",attrs:{"color":"gray","hollow":""},on:{"click":_vm.clear}},[_vm._v("重置")])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }